import { api } from '@/api';
import type {
  ClientCreate,
  ClientDetail,
  ClientRecord,
  ClientUpdate,
  MyProfessional,
} from '@/api/types';

export const clientKeys = {
  list: (search: string, status: string) => ['clients', 'list', search, status] as const,
  detail: (id: string) => ['clients', 'detail', id] as const,
  myProfessionals: ['clients', 'my-professionals'] as const,
};

export const clientsApi = {
  list: (search: string, status: string) =>
    api.get<ClientRecord[]>('/clients', {
      query: { search: search || undefined, status: status || undefined },
    }),
  get: (id: string) => api.get<ClientDetail>(`/clients/${id}`),
  create: (body: ClientCreate) => api.post<ClientRecord>('/clients', body),
  update: (id: string, body: ClientUpdate) => api.patch<ClientRecord>(`/clients/${id}`, body),
  myProfessionals: () => api.get<MyProfessional[]>('/clients/me/professionals'),
  setSharing: (
    linkId: string,
    body: { shareNutrition?: boolean; shareHealth?: boolean; shareFinance?: boolean },
  ) => api.patch<MyProfessional[]>(`/clients/me/professionals/${linkId}`, body),
};
